import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { com.demo.portfolio_demo.pages.HomePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", com.demo.portfolio_demo.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.demo.portfolio_demo.SubheadlineTextStyle)
        ctx.theme.registerStyle("markdown",
                com.demo.portfolio_demo.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content",
                com.demo.portfolio_demo.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("footer", com.demo.portfolio_demo.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header",
                com.demo.portfolio_demo.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("about", com.demo.portfolio_demo.components.styles.AboutStyle)
        ctx.theme.registerStyle("background-image",
                com.demo.portfolio_demo.components.styles.BackgroundImageStyle)
        ctx.theme.registerStyle("button", com.demo.portfolio_demo.components.styles.ButtonStyle)
        ctx.theme.registerStyle("co-activity",
                com.demo.portfolio_demo.components.styles.CoActivityStyle)
        ctx.theme.registerStyle("co-activity-item-title",
                com.demo.portfolio_demo.components.styles.CoActivityItemTitleStyle)
        ctx.theme.registerStyle("hero-section",
                com.demo.portfolio_demo.components.styles.HeroSectionStyle)
        ctx.theme.registerStyle("hello-im", com.demo.portfolio_demo.components.styles.HelloImStyle)
        ctx.theme.registerStyle("user-name",
                com.demo.portfolio_demo.components.styles.UserNameStyle)
        ctx.theme.registerStyle("users-message",
                com.demo.portfolio_demo.components.styles.UsersMessageStyle)
        ctx.theme.registerStyle("research-item-subtitle",
                com.demo.portfolio_demo.components.styles.ResearchItemSubtitleStyle)
        ctx.theme.registerStyle("research-item-title",
                com.demo.portfolio_demo.components.styles.ResearchItemTitleStyle)
        ctx.theme.registerStyle("research", com.demo.portfolio_demo.components.styles.ResearchStyle)
        ctx.theme.registerStyle("section-title",
                com.demo.portfolio_demo.components.styles.SectionTitleStyle)
        ctx.theme.registerStyle("section-description",
                com.demo.portfolio_demo.components.styles.SectionDescriptionStyle)
        ctx.theme.registerStyle("work-experience-item-role-and-duration",
                com.demo.portfolio_demo.components.styles.WorkExperienceItemRoleAndDurationStyle)
        ctx.theme.registerStyle("work-experience-item-org",
                com.demo.portfolio_demo.components.styles.WorkExperienceItemOrgStyle)
        ctx.theme.registerStyle("experience",
                com.demo.portfolio_demo.components.styles.ExperienceStyle)
        ctx.theme.registerStyle("writings", com.demo.portfolio_demo.components.styles.WritingsStyle)
        ctx.theme.registerStyle("arrow-up", com.demo.portfolio_demo.components.widgets.ArrowUpStyle)
        ctx.theme.registerStyle("back-to-top-button",
                com.demo.portfolio_demo.components.widgets.BackToTopButtonStyle)
        ctx.theme.registerStyle("footer-icons",
                com.demo.portfolio_demo.components.widgets.FooterIconsStyle)
        ctx.theme.registerVariant("-circle", com.demo.portfolio_demo.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", com.demo.portfolio_demo.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes(com.demo.portfolio_demo.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("hero-container-key-frames",
                com.demo.portfolio_demo.components.styles.HeroContainerKeyFrames)
        ctx.theme.registerKeyframes("fade-in-key-frames",
                com.demo.portfolio_demo.components.widgets.FadeInKeyFrames)
        com.demo.portfolio_demo.initColorMode(ctx)
        com.demo.portfolio_demo.initSiteStyles(ctx)
        com.demo.portfolio_demo.initTheme(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "Portfolio Demo"))
    renderComposable(rootElementId = "root") {
        com.demo.portfolio_demo.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
